module.exports = __webpack_public_path__ + "img/icons_UI_icon_missed.b2b50221.svg";